import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b98336a8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "cms-module-title mg-t--20"
};
const _hoisted_2 = {
  class: "cms-module-title mg-t--20"
};
const _hoisted_3 = {
  class: "relevance-sub-warp"
};
import { addDecimal } from '@/utils/validate';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckDetailDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: {
        name: '',
        period: '',
        createTime: '',
        promotionalProductName: ''
      }
    },
    priceData: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const checkTableConfig = reactive({
      data: props.priceData,
      isCardBlock: false,
      loading: false,
      isShowHeader: false,
      showPageBar: false,
      columnList: [{
        label: '服务列表名称',
        prop: 'serviceList',
        formatter: val => {
          if (val && val.length) {
            let formateTextArr = [];
            val.forEach(item => {
              formateTextArr.push(item.name);
            });
            return formateTextArr.join(',');
          }
        }
      }, {
        label: '服务期',
        prop: 'period',
        formatter: val => {
          if (val) {
            return val + t('个月');
          }
        }
      }, {
        label: '终端显示名称',
        prop: 'terminalName'
      }, {
        label: '价格(美元)',
        prop: 'price',
        formatter: val => {
          if (val) {
            return `$${addDecimal(val)}`;
          }
        }
      }]
    });
    const checkForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '促销方案名称',
        prop: 'name',
        widgetType: 'text'
      }], [{
        label: '促销周期',
        prop: 'period',
        widgetType: 'text'
      }], [{
        label: '编辑时间',
        prop: 'createTime',
        widgetType: 'text'
      }], [{
        label: '促销产品',
        prop: 'promotionalProductName',
        widgetType: 'text'
      }]],
      dialogConfig: {
        title: '查看',
        destroyOnClose: true
      },
      confirm: () => {
        checkForm.visible = false;
      }
    });
    watch(() => props.priceData, val => {
      checkTableConfig.data = val;
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_FormTable = _resolveComponent("FormTable");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_m_dialog, {
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        "dialog-config": checkForm.dialogConfig,
        nativeConfig: {
          width: '40%',
          closeOnClickModal: false
        },
        onOnConfirm: checkForm.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_FormTable, {
          ref: "formRef",
          "form-list": checkForm.formList,
          "form-data": __props.formData
        }, null, 8, ["form-list", "form-data"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('单价')), 1), _createVNode(_component_common_table, {
          ref: "checkTableRef",
          style: {
            "width": "100%"
          },
          "table-config": checkTableConfig,
          options: checkTableConfig.options,
          render: () => {}
        }, {
          default: _withCtx(() => [_createVNode(_component_column, {
            "column-list": checkTableConfig.columnList
          }, null, 8, ["column-list"])]),
          _: 1
        }, 8, ["table-config", "options", "render"])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('已关联子品牌')), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
          name: 'FTV'
        }, {
          name: 'VOD'
        }, {
          name: '子品牌一'
        }, {
          name: '子品牌二'
        }, {
          name: '子品牌三'
        }, {
          name: '子品牌三'
        }, {
          name: '子品牌四'
        }, {
          name: '子品牌五'
        }], (item, index) => {
          return _createElementVNode("span", {
            class: "sub-item",
            key: index
          }, _toDisplayString(item.name), 1);
        }), 64))])])])), [[_directive_loading, __props.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"]);
    };
  }

});